import { render } from "./KnowledgeCoursesView.vue?vue&type=template&id=d1645fd6&scoped=true"
import script from "./KnowledgeCoursesView.vue?vue&type=script&lang=js"
export * from "./KnowledgeCoursesView.vue?vue&type=script&lang=js"

import "./KnowledgeCoursesView.vue?vue&type=style&index=0&id=d1645fd6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1645fd6"]])

export default __exports__